<template>
  <div id="avatar">
    <section class="pantalla">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <!-- <div class="xander abs" data-aos="fade-right" data-aos-delay="1000">
              <img
                src="../assets/imgs/avatar/xander-default.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div> -->

            <!-- <div class="omega abs" data-aos="fade-left" data-aos-delay="1200">
              <img
                src="../assets/imgs/avatar/omega-default.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div> -->

            <div class="personajes abs" data-aos="fade-up" data-aos-delay="200">
              <div v-show="personaje_seleccionado == 1" class="maya abs">
                <img
                  :class="{ selected: maya_outfit == -1 }"
                  src="../assets/imgs/avatar/maya-default.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <img
                  :class="{ selected: maya_outfit == 1 }"
                  src="../assets/imgs/avatar/maya-1.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <img
                  :class="{ selected: maya_outfit == 2 }"
                  src="../assets/imgs/avatar/maya-2.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="nombre_personaje fG amarillo bold">
                  {{ nombre_personaje }}
                </div>
              </div>

              <div v-show="personaje_seleccionado == 2" class="xander abs">
                <img
                  :class="{ selected: xander_outfit == -1 }"
                  src="../assets/imgs/avatar/xander-default.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <img
                  :class="{ selected: xander_outfit == 1 }"
                  src="../assets/imgs/avatar/xander-1.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <img
                  :class="{ selected: xander_outfit == 2 }"
                  src="../assets/imgs/avatar/xander-2.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="nombre_personaje fG amarillo bold">
                  {{ nombre_personaje }}
                </div>
              </div>

              <div v-show="personaje_seleccionado == 3" class="omega abs">
                <img
                  :class="{ selected: omega_outfit == -1 }"
                  src="../assets/imgs/avatar/omega-default.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <img
                  :class="{ selected: omega_outfit == 1 }"
                  src="../assets/imgs/avatar/omega-1.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <img
                  :class="{ selected: omega_outfit == 2 }"
                  src="../assets/imgs/avatar/omega-2.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <div class="nombre_personaje fG amarillo bold">
                  {{ nombre_personaje }}
                </div>
              </div>
            </div>

            <div
              @click="siguiente()"
              class="flechader abs"
              data-aos="fade"
              data-aos-delay="800"
            >
              <img
                src="../assets/imgs/mision/flecha-der.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div
              @click="anterior()"
              class="flechaizq abs"
              data-aos="fade"
              data-aos-delay="800"
            >
              <img
                src="../assets/imgs/mision/flecha-izq.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="personaliza abs" data-aos="fade" data-aos-delay="800">
              <img
                src="../assets/imgs/avatar/btn-personaliza.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="botonera abs" data-aos="fade" data-aos-delay="800">
              <div class="maya" v-show="personaje_seleccionado == 1">
                <img
                  @click="selecciona('maya', 1)"
                  :class="{ selected: maya_outfit == 1 }"
                  src="../assets/imgs/avatar/maya-opcion-1.png"
                  alt="Encauce"
                  class="img-fluid maya-1 pointer rounded p-1"
                />
                <img
                  @click="selecciona('maya', 2)"
                  :class="{ selected: maya_outfit == 2 }"
                  src="../assets/imgs/avatar/maya-opcion-2.png"
                  alt="Encauce"
                  class="img-fluid maya-2 pointer rounded p-1"
                />
              </div>
              <div class="maya" v-show="personaje_seleccionado == 2">
                <img
                  @click="selecciona('xander', 1)"
                  :class="{ selected: xander_outfit == 1 }"
                  src="../assets/imgs/avatar/xander-opcion-1.png"
                  alt="Encauce"
                  class="img-fluid maya-1 pointer rounded p-1"
                />
                <img
                  @click="selecciona('xander', 2)"
                  :class="{ selected: xander_outfit == 2 }"
                  src="../assets/imgs/avatar/xander-opcion-2.png"
                  alt="Encauce"
                  class="img-fluid maya-2 pointer rounded p-1"
                />
              </div>
              <div class="maya" v-show="personaje_seleccionado == 3">
                <img
                  @click="selecciona('omega', 1)"
                  :class="{ selected: omega_outfit == 1 }"
                  src="../assets/imgs/avatar/omega-opcion-1.png"
                  alt="Encauce"
                  class="img-fluid maya-1 pointer rounded p-1"
                />
                <img
                  @click="selecciona('omega', 2)"
                  :class="{ selected: omega_outfit == 2 }"
                  src="../assets/imgs/avatar/omega-opcion-2.png"
                  alt="Encauce"
                  class="img-fluid maya-2 pointer rounded p-1"
                />
              </div>
            </div>

            <div class="cont-btn-sig btn-avanzar col-12">
              <button @click="avanzar" class="btn-sig">
                <span class="texto">
                  <span class="bold">CONTINUAR</span>
                </span>
                <img
                  class="icono"
                  src="../assets/imgs/mision/cohete.png"
                  alt="icono"
                />
                <span class="flecha">
                  <img
                    src="../assets/imgs/mision/flecha-sig3.png"
                    alt="icono"
                  />
                </span>
              </button>
              <div class="flecha2">
                <img src="../assets/imgs/mision/flecha-sig2.png" alt="icono" />
              </div>
              <div class="flecha1">
                <img src="../assets/imgs/mision/flecha-sig1.png" alt="icono" />
              </div>
            </div>

            <!-- <div class="row no-gutters centradoxy" data-aos="fade-up" data-aos-delay="400">
              <div class="col-12 dialogo text-center blanco mb5">
                <p>Podrás identificar tu potencial y construir la mejor versión de ti. Desarrolla tu <strong>identidad</strong>, <strong>autonomía</strong> y tu <strong>capacidad</strong> de proyección personal. <br> Descubre tu fortaleza, visiona tu propósito y encuentra el mejor camino para desarrollarlo.</p>
              </div>
              <div class="col-12 text-center">
                <button @click="avanzar()" class="btn-generico">ACEPTAR EL DESAFÍO</button>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      maya_outfit: -1,
      xander_outfit: -1,
      omega_outfit: -1,
      personaje_seleccionado: 1,
      condicion: false,
      settings: {
        personaje: null,
      },
      nombre_personaje: "Maya",
      slug_personaje: "",
      id_outfit: ""
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    async avanzar() {
      if (this.condicion == false) {
        swal.fire(
          "Oops",
          "Personaliza tu avatar antes de continuar...",
          "warning"
        );
        return;
      }

      let data = {
        index_mision: "avatar",
        write: {
          mision: "avatar",
          slug_personaje: this.slug_personaje,
          id_outfit: this.id_outfit
        }
      };

      await this.$store.dispatch("registroPersonaje", data);

      router.push("/progreso");
    },
    selecciona(personaje, outfit) {
      switch (personaje) {
        case "maya":
          this.maya_outfit = outfit;
          this.condicion = true;
          this.slug_personaje = "maya";
          this.id_outfit = outfit;
          break;
        case "xander":
          this.xander_outfit = outfit;
          this.condicion = true;
          this.slug_personaje = "xander";
          this.id_outfit = outfit;
          break;
        case "omega":
          this.omega_outfit = outfit;
          this.condicion = true;
          this.slug_personaje = "omega";
          this.id_outfit = outfit;
          break;
      }

      localStorage.setItem("personaje", this.slug_personaje.toString() + '-' + this.id_outfit.toString());
    },
    siguiente() {
      this.personaje_seleccionado++;

      if (this.personaje_seleccionado == 4) {
        this.personaje_seleccionado = 1;
      }

      this.seleccionaNombre();
    },
    anterior() {
      this.personaje_seleccionado--;

      if (this.personaje_seleccionado == 0) {
        this.personaje_seleccionado = 3;
      }
      this.seleccionaNombre();
    },
    seleccionaNombre() {
      switch (this.personaje_seleccionado) {
        case 1:
          this.nombre_personaje = "Maya";
          break;
        case 2:
          this.nombre_personaje = "Xander";
          break;
        case 3:
          this.nombre_personaje = "Omega";
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$amarillo: #ffcc00;
#avatar {
  background: url(../assets/imgs/avatar/bg-avatar.jpg) no-repeat;
  background-size: cover;
  background-position: top center;
  .contentabs {
    .logo {
      bottom: 5%;
      left: 5%;
      width: 20%;
      position: absolute;
    }
    .centradoxy {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 80%;
      left: 50%;
    }
    .maya,
    .xander,
    .omega {
      bottom: 2%;
      left: 50%;
      width: 20%;
      position: relative;
      img {
        display: none;
        &.selected {
          display: block;
        }
      }
      .nombre_personaje {
        width: 100%;
        position: absolute;
        top: -30%;
        left: -15%;
        text-align: center;
      }
    }

    .personajes {
      position: absolute;
      top: 30%;
      left: 11%;
      width: 80vw;
      height: 90vh;
    }

    /*.xander {
      bottom: 10%;
      left: 35%;
      width: 13%;
    }
    .omega {
      bottom: 10%;
      left: 65%;
      width: 11%;
    }*/

    .personaliza {
      width: 20%;
      top: 12%;
      left: 6%;
    }

    .botonera {
      width: 20%;
      top: 26%;
      left: 6%;
      position: relative;
      .maya {
        left: 0;
        top: 0;
        width: 100%;
        position: relative;
        img {
          display: block;
        }
        .maya-1 {
          position: absolute;
          width: 40%;
          left: 0%;
          top: 10%;
          border: 2px solid transparent;
          &.selected {
            border: 2px solid $amarillo;
          }
        }
        .maya-2 {
          position: absolute;
          width: 40%;
          left: 50%;
          top: 20%;
          border: 2px solid transparent;
          &.selected {
            border: 2px solid $amarillo;
          }
        }
      }
    }

    .btn-avanzar {
      position: absolute;
      bottom: 2%;
      left: 65%;
    }

    .flechaizq {
      position: absolute;
      width: 8vw;
      top: 20vw;
      left: 35%;
      cursor: pointer;
    }
    .flechader {
      position: absolute;
      width: 8vw;
      top: 20vw;
      left: 70%;
      cursor: pointer;
    }

    @media (min-width: 993px) {
      .maya,
      .xander,
      .omega {
        bottom: 10%;
        left: 45%;
        width: 23%;
        .nombre_personaje {
          width: 100%;
          position: absolute;
          top: -20%;
          left: -15%;
          text-align: center;
          font-size:40px;
        }
      }
      /*.xander {
        bottom: 20%;
        left: 30%;
        width: 20%;
      }
      .omega {
        bottom: 20%;
        left: 65%;
        width: 16%;
      }*/
    }
  }
}
</style>
